
import '../styles/ConfigStepper.scss'
import { useEffect, useState } from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";



const getNextStepTitle = (steps) => {
    if (!Array.isArray(steps)) return null;
    for (let i = 0; i < steps.length; i++) {
        const step = steps[i];
        if (step.status === "Pending") {
            if (i === 0 || steps[i - 1].status === "Completed") {
                return step.title;
            }
        }
        else if (step.status === "Error") {
            return step.title
        }
    }
    return 'InProgress'

}
const getButtonStep = (steps) => {
    if (!Array.isArray(steps)) return null;
    const lastCompletedIndex = steps.map(s => s.status).lastIndexOf("Completed");
    if (lastCompletedIndex === -1) return null;
    if (lastCompletedIndex === steps.length - 1) return null;
    const nextStep = steps[lastCompletedIndex + 1];

    if (nextStep.status === "Pending" || nextStep.status === "Error") {
        return steps[lastCompletedIndex];
    }

    return null;
};

export default function ConfigStepper({ steps, onStepClick, isAnyInProgress }) {
    const [nextTitle, setNextTitle] = useState(null);
    const [showBtn, setShowBtn] = useState(null);

    useEffect(() => {
        if (steps && steps.length > 0) {
            const title = getNextStepTitle(steps);
            setNextTitle(title);
            const buttonStep = getButtonStep(steps);
            setShowBtn(buttonStep)
        }
    }, [steps]);
    return (
        <div className="stepperSection">
            <div className="stpperDiv">
                {steps.map((step, i) => (
                    <div key={step.id}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{
                                color: step.status === 'Completed' ? '#34ebeb' :
                                    step.status === 'In Progress' ? 'orange' :
                                        step.status === 'Error' ? 'red' : 'grey'
                            }}>
                                {/* {step.status === 'Completed' && <FaCircleCheck className="completedIcon" />}
                                {step.status === 'In Progress' && <FaCircle className="progressIcon" />}
                                {step.status === 'Pending' && <FaCircle className="pendingIcon" />}
                                {step.status === 'Error' && <FaCircleXmark className="errorIcon" />} */}
                                <span className="stepID">{step.id}</span>
                            </div>
                            {/* <label className="stepText">STEP {step.id}</label> */}
                            <label className="stepText">{step.title}</label>
                        </div>
                        <div
                            style={{
                                ...(i !== steps.length - 1 && {
                                    // borderLeft: step.status === 'Completed' ? '1px dotted #365e3d' :
                                    //     step.status === 'Error' ? '1px dotted #d04a01' : '1px dotted #ccc',
                                    borderLeft: '1px dotted #e0301e',
                                    marginBottom: 2,
                                    marginTop: 3
                                }),
                            }}
                            className="stepDesc"
                        >
                            {/* {step.title} 
                             <br /> */}
                            <span
                                className={`statusText ${step.status === 'In Progress' ? 'inProgress' : ''}`}
                                style={{
                                    color: step.status === 'Completed' ? '#34ebeb' :
                                        step.status === 'In Progress' ? '#E88D14' :
                                            step.status === 'Error' ? '#d04a01' :
                                                step.status === 'Pending' ? '#e0301e' : ''
                                }}
                            >
                                {step.status}
                            </span><br />

                            {(step.error && step.status === 'Error') && (
                                <div className="errorDesc">
                                    {step.error}
                                </div>
                            )}
                            {(showBtn?.id === step.id) //&& (step.id !== 4)
                                && (
                                    <div className="stepperBtnSection">
                                        <button
                                            className="submitButton"
                                            onClick={() => onStepClick(step.id)}
                                            disabled={isAnyInProgress}
                                        >
                                            {/* {nextTitle} */}
                                            Next <MdOutlineKeyboardArrowRight className='nextIcon' />
                                        </button>
                                    </div>
                                )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
